'use client';

import React from 'react';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/contexts/AuthContext';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      {children}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            fontFamily: 'var(--font-plus-jakarta-sans)',
            borderRadius: '10px',
            border: '1px solid var(--border)',
          },
        }}
      />
    </AuthProvider>
  );
}
